import { createAsyncThunk } from "@reduxjs/toolkit";
import { type_constant } from "../../utils/contants/asyncStatus";
import { apiHandle } from "../../config/apiHandle";


export const check_auth = createAsyncThunk(
  type_constant.CHECK_AUTH,
  async () => {
    try {
      const response = await apiHandle.get(`check-auth`);
      const res_data = await response.data;
      console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const login_service_auth = createAsyncThunk(
  type_constant.LOGIN,
  async (post_data) => {
    try {
      const response = await apiHandle.post(`/admin-login`, post_data);
      const res_data = await response.data;
      console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const get_users = createAsyncThunk(
  type_constant.GET_USERS,
  async (post_data) => {
    try {
      const response = await apiHandle.get(`user/get-admin-users/User`);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const get_vendor = createAsyncThunk(
  type_constant.GET_VENDOR,
  async (post_data) => {
    try {
      const response = await apiHandle.get(`user/get-admin-users/Vendor`);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const get_category = createAsyncThunk(
  type_constant.GET_CATEGORY,
  async (post_data) => {
    try {
      const response = await apiHandle.get(`user/get-categories`);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const add_category = createAsyncThunk(
  type_constant.ADD_CATEGORY,
  async (post_data) => {
    try {
      const response = await apiHandle.post(`user/add-category`,post_data);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const update_category = createAsyncThunk(
  type_constant.UPDATE_CATEGORY,
  async (post_data) => {
    try {
      const response = await apiHandle.patch(`/user/update-category/${post_data?.id}`,post_data);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const delete_category = createAsyncThunk(
  type_constant.DELETE_CATEGORY,
  async (post_data) => {
    try {
      const response = await apiHandle.delete(`/user/delete-category/${post_data}`);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const get_dashboard = createAsyncThunk(
  type_constant.GET_DASHBOARD,
  async (post_data) => {
    try {
      const response = await apiHandle.get(`user/admin-dashboard`);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const get_all_ads = createAsyncThunk(
  type_constant.GET_ALL_ADS,
  async (post_data) => {
    try {
      const response = await apiHandle.get(`user/get-all-ads`);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const block_ad = createAsyncThunk(
  type_constant.BLOCK_AD,
  async (post_data) => {
    try {
      const response = await apiHandle.post(`user/block-ublock`,post_data);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const block_user = createAsyncThunk(
  type_constant.BLOCK_USER,
  async (post_data) => {
    try {
      const response = await apiHandle.post(`user/block-unblock-user`,post_data);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const update_user = createAsyncThunk(
  type_constant.UPDATE_USER,
  async (post_data) => {
    try {
      const response = await apiHandle.patch(`/user/update-user-admin/${post_data?.id}`,post_data);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const delete_user = createAsyncThunk(
  type_constant.DELETE_USER,
  async (post_data) => {
    try {
      const response = await apiHandle.delete(`/user/delete-user/${post_data}`);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const add_user = createAsyncThunk(
  type_constant.ADD_USER,
  async (post_data) => {
    try {
      const response = await apiHandle.post(`user/add-user-admin`,post_data);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
